// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1n97a","label":"Category_label__1bZ4c","content":"Category_content__2q9bo","header":"Category_header__mx-e9","location":"Category_location__1WaZH"};